module.exports = __webpack_public_path__ + "img/complete_logo.c86db727.png";